// @flow

import getGoogleAnalyticsTrackingId from './getGoogleAnalyticsTrackingId';


// -----------------------------------------------------------------------------------------------------------------
// Config
// -----------------------------------------------------------------------------------------------------------------

const gtagConfig = {'anonymize_ip': true};


// -----------------------------------------------------------------------------------------------------------------
// Main function
// -----------------------------------------------------------------------------------------------------------------

function configureGoogleAnalytics() {
  const gtag = require('./gtag').default;
  gtag('js', new Date());
  gtag('config', getGoogleAnalyticsTrackingId(), gtagConfig);
}


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default configureGoogleAnalytics;



// WEBPACK FOOTER //
// ./src/analytics/google-analytics/configureGoogleAnalytics.js